import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Password from '../Common/Password';

const PasswordUpdate = observer(class PasswordUpdate extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.updatePassword = this.updatePassword.bind(this);
  }

  confirmPassword(e) {
    e.preventDefault();

    // Make sure confirm password matches
    let newPass = document.querySelector('#password-new');
    let confirm = document.querySelector('#password-confirm');

    if(newPass.value !== this.confirmPass.value) {
      confirm.setCustomValidity('Passwords do not match.');
    } else {
      confirm.setCustomValidity('');
    }

    this.props.checkValidity(e, this.updatePassword);
  }

  updatePassword() {
    const { SettingsStore } = this.props.store;
    let newPass = document.querySelector('#password-new');

    const data = {
      currentPassword: this.currentPass.value,
      newPassword: newPass.value,
      confirmPassword: this.confirmPass.value
    }

    SettingsStore.updatePassword(data, this.props.nextStep);
  }

  render() {
    const { translation } = this.props;
    const { userData } = this.props.store.SessionStore;

    return(
      <form
        className="panel"
        onSubmit={(e) => this.confirmPassword(e)}
        noValidate
      >
        <div className="panel__header">
          <h3 className="panel__title">
            <legend>{translation.heading}</legend>
          </h3>
        </div>

        <div className="panel__body">
          <p className="note note--prominent">
            {translation.body}
          </p>

          <fieldset>
            <ul className="fields">
              {!userData.passwordChangeKey &&
                <li>
                  <label className="lbl-required" htmlFor="password-current">
                    {translation.current_password}
                  </label>

                  <input
                    id="password-current"
                    type="password"
                    ref={(input) => {this.currentPass = input}}
                    required
                    aria-required="true"
                  />
                </li>
              }
              <li>
                <label className="lbl-required" htmlFor="password-new">
                  {translation.new_password}
                </label>

                <Password
                  id="password-new"
                  parent={this}
                  name="password"
                  {...this.props}
                />
              </li>
              <li>
                <label className="lbl-required" htmlFor="password-confirm">
                  {translation.confirm_password}
                </label>

                <input
                  id="password-confirm"
                  type="password"
                  ref={(input) => this.confirmPass = input}
                  required
                  aria-required="true"
                />
              </li>
            </ul>
          </fieldset>

          <div className="panel__actions actions">
            <button
              className="actions__btn actions__btn--secondary"
              onClick={this.props.prevStep}
              type="button"
            >
              {translation.back}
            </button>

            <button
              className="actions__btn actions__btn--primary"
              type="submit"
            >
              {translation.button}
            </button>
          </div>
        </div>
      </form>
    )
  }
})

export default translate('PasswordUpdate')(PasswordUpdate);



// WEBPACK FOOTER //
// ./src/app/components/Checkup/PasswordUpdate.js